import { trans } from "@mongez/localization";
import { useLoaderData } from "@remix-run/react";
import { pageHead } from "framework/config/meta";
import { publicRoutes } from "framework/config/middlewares";
import { FlavorListPage } from "~/modules/flavors/pages";
import { getFlavorListService } from "~/modules/flavors/services";

export const loader = publicRoutes(async ({ http, success, catchErrors }) => {
  try {
    const data = await getFlavorListService(http);

    return success(data);
  } catch (error) {
    return catchErrors(error);
  }
});

export const meta = () => {
  return pageHead({
    title: trans("flavorList"),
    appendAppName: true,
  });
};

export default function FlavorList() {
  const data = useLoaderData<typeof loader>();

  return <FlavorListPage data={data} />;
}
